import { CardText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import type { ExploreLabelProps } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import { Assets } from '@Utils/AssetsStore';
import { a, easings, useSpring } from '@react-spring/three';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_Merchandiser>;
  animatedIn: boolean;
  zRange?: [number, number];
};

export function MerchandiserExploreLabel({
  animatedIn,
  gridCard,
  zRange = [0, 0.1],
}: Props) {
  const { exploreLabel } = gridCard.data!.internals!;
  const { text, fontSize, anchorY, lineHeight, color } = exploreLabel;
  const { dScale, dx, dy } = useAnimatedStates(animatedIn, exploreLabel);
  const [zMin] = zRange;

  return (
    <a.group scale={dScale} position-x={dx} position-y={dy} position-z={zMin}>
      <CardText
        text={text ?? 'Explore the collection'}
        color={color}
        fontSize={fontSize}
        fontAsset={Assets.Font_Gilroy_Bold}
        anchorX='left'
        anchorY={anchorY}
        letterSpacing={0.03}
        position={{ x: 0, y: 0 }}
        lineHeight={lineHeight}
        zPosition={zMin}
      />
    </a.group>
  );
}

const useAnimatedStates = (
  animatedIn: boolean,
  { position, animateOutPosition }: ExploreLabelProps
) =>
  useSpring({
    from: {
      dScale: animatedIn ? 1.2 : 1,
      dx: animatedIn ? animateOutPosition.x : position.x,
      dy: animatedIn ? animateOutPosition.y : position.y,
    },
    to: {
      dScale: animatedIn ? 1 : 1.2,
      dx: animatedIn ? position.x : animateOutPosition.x,
      dy: animatedIn ? position.y : animateOutPosition.y,
    },
    config: { duration: 1000, easing: easings.easeOutExpo },
  });
